import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppThunk } from '../store'

interface ComponentState {
  sidebarCollapsed: boolean
  /** Below the `md` breakpoint the rail is hidden and opens as a drawer from the navbar instead. */
  mobileNavOpen: boolean
}

const initialState: ComponentState = {
  sidebarCollapsed: false,
  mobileNavOpen: false,
}

const componentSlice = createSlice({
  name: 'components',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    },
    setMobileNavOpen(state, { payload }: PayloadAction<boolean>) {
      state.mobileNavOpen = payload
    },
  },
})

export const { toggleSidebar, setMobileNavOpen } = componentSlice.actions

export const updateSidebar = (): AppThunk => async (dispatch) => {
  dispatch(toggleSidebar())
}

export default componentSlice.reducer
